import { t } from '@lingui/macro'

const PostTypeTitle = ({ type, variant = '' }) => {
  const postTypeTitles = {
    publications: t`Publications`,
    publications_idpc: t`IDPC Publications`,
    publications_members: t`Publications from IDPC Members`,
    news: t`News`,
    blog: t`Blog`,
    events: t`Events`,
    events_past: t`Past Events`,
    media: t`IDPC in the Media`,
    press: t`Press Releases`,
    search: t`Search Results`,
  }
  return postTypeTitles[`${type}${variant !== '' ? `_${variant}` : ``}`]
}
export default PostTypeTitle
